module.exports = __webpack_public_path__ + "static/reductions-183457657803a61b9297002031a8964e.png";